// CreateAdmin.tsx
import React, { useEffect, useState } from "react";
import { Modal, Button, Select, NumberInput, Grid, Group, MultiSelect } from "@mantine/core";
import { AddStaffKPI } from "./types";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import classes from "./Staff.module.css";

interface CreateStaffProps {
  isVisible: boolean;
  onClose: () => void;
  onAddStaffKpi: (NewStaffKpi: AddStaffKPI) => void;
}

type availableOptions = {
  value: string;
  label: string;
};

const AddKPI: React.FC<CreateStaffProps> = ({
  isVisible,
  onClose,
  onAddStaffKpi,
}) => {
  const [addStaffKpi, setAddStaffKpi] = useState<AddStaffKPI>({
    staffId: [],
    timePeriodId: 0,
    duration: "",
    objectiveId: "",
    targetPoints: "",
  });

  const handleAddStaff = () => {
    // Check if any field is empty
    if (
      addStaffKpi.staffId.length === 0 ||
      !addStaffKpi.timePeriodId ||
      !addStaffKpi.duration ||
      !addStaffKpi.objectiveId ||
      !addStaffKpi.targetPoints
    ) {
      // Display a warning message (you can use a library or create a custom modal for this)
      alert("Please fill in all of the required details");
      return;
    }

    // Check if the passwords match

    // Validation passed, proceed with adding the customer
    onAddStaffKpi({
      ...addStaffKpi,
    });

    setAddStaffKpi({
      staffId: [],
      timePeriodId: 0,
      duration: "",
      objectiveId: "",
      targetPoints: "",
    });

    onClose();
  };

  const [availableObjectives, setAvailableObjectives] = useState<
    availableOptions[] | null
  >(null);
  const [availableStaffs, setAvailableStaffs] = useState<
    availableOptions[] | null
  >(null);
  const [availablePeriods, setAvailablePeriods] = useState<
    availableOptions[] | null
  >(null);

  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    axiosPrivate
      .get("/api/admin/kpi/objective/read-all?show=kpi_objective_id&show=title")
      .then((response) => {
        const datas: availableOptions[] = [];
        response.data.objectives.forEach((el: any) => {
        //   console.log(el.kpi_objective_id);
          datas.push({
            value: el.kpi_objective_id,
            label: el.title,
          });
        });
        setAvailableObjectives(datas);
      })
      .catch((error) => {
        setAvailableObjectives(null);
      });

    axiosPrivate
      .get("/api/admin/staff/read-all?show=fullname&show=staff_id")
      .then((response) => {
        const datas: availableOptions[] = [];
        response.data.staffs.forEach((el: any) => {
          datas.push({
            value: el.staff_id,
            label: el.fullname,
          });
        });
        setAvailableStaffs(datas);
        // console.log(datas);
      })
      .catch((error) => {
        setAvailableStaffs(null);
      });

    axiosPrivate
      .get("/api/kpi/time/read-all")
      .then((response) => {
        const datas: availableOptions[] = [];
        response.data.periods.forEach((el: any) => {
          datas.push({
            value: `${el.id}`,
            label: `${el.type.charAt(0).toUpperCase()}${el.type.slice(1)}`,
          });
        });
        setAvailablePeriods(datas);
        // console.log(datas);
      })
      .catch((error) => {
        setAvailablePeriods(null);
      });
  }, []);

  return (
    <Modal
      opened={isVisible}
      onClose={onClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>New KPI</div>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddStaff();
        }}
      >
        <div className={classes.spacing}>
          {availableStaffs == null ? (
            <Select
              label="Staff"
              required
              data={[]}
            />
          ) : (
            <MultiSelect
              label="Staff"
              placeholder="Select staff"
              required
              data={availableStaffs}
              onChange={(value) =>
                setAddStaffKpi({ ...addStaffKpi, staffId: value!! })
              }
            />
          )}
          {availableObjectives == null ? (
            <Select
              label="Objective"
              placeholder="Select objective"
              required
              data={[]}
            />
          ) : (
            <Select
              label="Objective"
              placeholder="Select objective"
              required
              data={availableObjectives}
              onChange={(value, option) =>
                setAddStaffKpi({ ...addStaffKpi, objectiveId: value!! })
              }
            />
          )}
          <Grid>
            <Grid.Col span={7}>
              {availablePeriods == null ? (
                <Select
                  label="Period"
                  placeholder="Select period"
                  required
                  data={[{ value: "1", label: "f" }]}
                />
              ) : (
                <Select
                  label="Period"
                  placeholder="Select period"
                  required
                  data={availablePeriods}
                  onChange={(value, option) =>
                    setAddStaffKpi({ ...addStaffKpi, timePeriodId: value!! })
                  }
                />
              )}
            </Grid.Col>
            <Grid.Col span={5}>
              <NumberInput
                style={{ flexGrow: 1 }}
                label="Duration"
                placeholder="Input duration"
                allowDecimal={false}
                allowNegative={false}
                max={10000}
                maxLength={999}
                value={addStaffKpi.duration}
                required
                onChange={(e) =>
                  setAddStaffKpi({ ...addStaffKpi, duration: e })
                }
                min={1}
              />
            </Grid.Col>
          </Grid>
          <NumberInput
            label="Target"
            placeholder="Input target points"
            allowDecimal={false}
            allowNegative={false}
            max={10000}
            value={addStaffKpi.targetPoints}
            required
            onChange={(e) =>
              setAddStaffKpi({ ...addStaffKpi, targetPoints: e })
            }
            min={1}
          />
          <Group className={classes.buttonBottom}>
            <Button onClick={() => onClose()} className={classes.buttonCancel}>
              Back
            </Button>
            <Button type="submit" className={classes.buttonSaveChanges}>
              Submit
            </Button>
          </Group>
        </div>
      </form>
    </Modal>
  );
};

export default AddKPI;
